export const MILLION = 1_000_000;

const formatFromScaledHundredths = (scaled: number): string => {
    const sign = scaled < 0 ? '-' : '';
    const absScaled = Math.abs(scaled);
    const integerPart = Math.trunc(absScaled / 100);
    const fractionalPart = absScaled % 100;

    return `${sign}${integerPart}.${String(fractionalPart).padStart(2, '0')}`;
};

export const formatMillions = (value: number): string => {
    if (value === 0) return '0.00';

    const truncatedScaled = Math.trunc((value / MILLION) * 100);
    const truncatedFormatted = formatFromScaledHundredths(truncatedScaled);

    if (truncatedFormatted !== '0.00') return truncatedFormatted;

    let roundedScaled = Math.round((value / MILLION) * 100);

    if (roundedScaled === 0) {
        roundedScaled = value > 0 ? 1 : -1;
    }

    return formatFromScaledHundredths(roundedScaled);
};
